module.exports = __webpack_public_path__ + "static/hillbilly-elegy-32695482ca69d51b1ba6064ad3a3ddd1.jpg";